import { useCheckForRenNumberInMessage } from '../../hooks/use-check-for-ren-number-in-message';
import { Flex, IconButton, Spacer, Text } from '@cad-arc';
import { formatShortTime } from '../../../common/helpers/utils';

interface UnitHistoryItemRowProps {
    unitHistoryItemView: {
        id: number;
        message: string;
        createdDateUtc: string;
    };
    openRenRmsLink: (link: string) => void;
}

const UnitHistoryItemRow: React.FC<UnitHistoryItemRowProps> = ({
    unitHistoryItemView,
    openRenRmsLink,
}) => {
    const { renNumber, showRenButton } = useCheckForRenNumberInMessage(unitHistoryItemView.message);
    return (
        <Flex>
            <Text variant="bodyMd" style={{ overflowWrap: 'anywhere' }}>
                {unitHistoryItemView.message}
                {showRenButton && (
                    <IconButton
                        variant="ghost"
                        icon="OpenNewWindow"
                        onClick={() => openRenRmsLink(renNumber)}
                        aria-label={`Open ${renNumber}`}
                        size="sm"
                    />
                )}
            </Text>

            <Spacer minWidth="24px" />
            <Text variant="bodyMd" color="tertiary">
                {formatShortTime(unitHistoryItemView.createdDateUtc, 'HH:mm:ss')}
            </Text>
        </Flex>
    );
};

export default UnitHistoryItemRow;
